<template>
    <div class="col-md-12">
        <NotificationsTable ref="notificationsTable"></NotificationsTable>
    </div>
</template>

<script>
import NotificationsTable from './NotificationsTable.vue';

export default {
    name: "ConfigSolicitations",
    components: {
        NotificationsTable
    },
    data() {
        return {}
    },
    created() {},
    methods: {
    }
}
</script>